import React,{Component} from 'react';
import{Route,Link,Switch} from 'react-router-dom'
import Add from './Add'
import Update from './Update'
import firebase from '../../config'
import {Box,Button} from '@material-ui/core'
import { Popconfirm} from 'antd';

export default class Package  extends Component{
    constructor(props){
        super(props)
        console.log(props)
        this.state = {
            data : []
        }
    }
    componentWillMount(){
        firebase.firestore().collection('packages').get().then(snap =>{
            var temp= [];
            snap.forEach(doc => {
                var obj = {
                    data : doc.data(),
                    id: doc.id
                }
                temp.push(obj)
            })
            setTimeout(() =>{
                this.setState({
                   data :temp
                },() => console.log(this.state))
            },3000)

        })
    }
    confirm =(id) =>{

        firebase.firestore().collection('packages').doc(id).delete().then(doc =>{
            alert("deleted")
        })

    }
    display = (props) =>{
        var data = props.data;
        var id =  props.id
        return <div>
                    <Box display="flex" flexDirection="row" justifyContent="space-between">
                        <Box>{data.name}</Box>
                        <Box>
                            <Box display="flex" flexDirection="row">
                                 <Box><Button><Link className="link-class" to={`/package/update/${id}`}>Edit</Link></Button></Box>
                                 <Box>

                                 <Popconfirm
                                    title="Are you sure delete this task?"
                                    onConfirm={()=>this.confirm(id)}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                     <Button >Delete</Button>
                                </Popconfirm>
                                     </Box>
                            </Box>
                        </Box>
                    </Box>
                    <br />
                </div>

    }
    render(){
       let arr = this.state.data
        if(this.props.location.pathname === "/package")
        return(
            <>
                  <Box textAlign="center" fontFamily="monospace" fontWeight="bold" fontSize="1.1em"> All Package</Box>
                {
                    arr.map(e =>{
                        return <this.display data={e.data} key={e.id} id={e.id} />
                    })
                }
            <Switch>
             <Route  path={`${this.props.match.path}/add`} component={Add} />
             <Route  path={`${this.props.match.path}/update/:id`} component={Update} />

            </Switch>
            
            </>
        )
        else return (
            <Switch>
            <Route  path={`${this.props.match.path}/add`} component={Add} />
            <Route  path={`${this.props.match.path}/update/:id`} component={Update} />

           </Switch>
        )
    }
}